import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { InvoiceReversalDialogComponent } from './invoice-reversal-dialog/invoice-reversal-dialog.component';
import { InvoiceReversalDialogData, InvoiceReversalTrackingHooks } from './invoice-reversal-dialog/invoice-reversal-dialog.models';

@Injectable({
  providedIn: 'root',
})
export class InvoiceReversalDialogService {
  private readonly dialog = inject(MatDialog);

  async openInvoiceReversalDialog(invoiceId: number, tracking?: InvoiceReversalTrackingHooks): Promise<boolean> {
    const dialogData: InvoiceReversalDialogData = { invoiceId, tracking };
    const dialogRef = this.dialog.open(InvoiceReversalDialogComponent, {
      data: dialogData,
      width: '500px',
      disableClose: false,
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    return result || false;
  }
}
